export default __webpack_public_path__ + "static/media/rangePositions.4511a4fc.svg";